<script lang="ts">
	import Avatar from '$lib/elements/Avatar.svelte';
	import type { AvatarProps } from '@app/types/Avatar';
	import { getInitials, getAccountStatus, getUserName } from '@app/utils/user';
	import { t } from 'svelte-i18n';
	import { page } from '$app/stores';

	export let props: AvatarProps;
	$: ({ user } = $page.data);

	$: props.state = getAccountStatus(user, $t).state;

	$: props.initials = getInitials(user?.identity?.firstName, getUserName(user));
	$: props.imageUrl = user?.avatar?.url;
	$: props.showStatus = true;
</script>

<Avatar {...props} on:click />
